import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules';
import * as DateTimeFormatUtils from '../../common/DateTimeFormatUtils';

const CpDateFormatter = (params: ValueFormatterParams): string => {
    const { node, value } = params;
    if (node && node.group) {
        return node.key != null ? node.key : '';
    }
    if (!value || (node && node.group)) {
        return '';
    }
    return DateTimeFormatUtils.formatDefaultDate(value);
};

export default CpDateFormatter;
